// @flow
/* eslint "jsx-a11y/click-events-have-key-events": "off", "jsx-a11y/no-static-element-interactions": "off" */

import React from 'react';

type Props = {
  item: any,
  search: any,
  index: number,
  limit?: number | string,
  hideItems: Function,
  url_param: string,
  count: number | string,
  pushToSearch: Function
};

const FilterItem = ({ item, index, limit, hideItems, count, pushToSearch, search, url_param }: Props) => {
  const queryParam = search[url_param];
  const checked = queryParam ? queryParam.find(el => el === item.id.toString()) : false;
  const isDisabled = count === 0 || !count;

  const handleClick = () => {
    if (!isDisabled) {
      const action = search[url_param] && search[url_param].includes(item.id.toString()) ? 'remove' : 'update';
      pushToSearch({ page: 0, [url_param]: item.id.toString() }, action);
    }
  };

  const renderFilterItem = () => (
    <div
      className={`filter__item${
        checked && !isDisabled ? ' active' : ''}${
        isDisabled ? ' disabled' : ''}`}
      onClick={() => handleClick()}
    >
      <div className="filter__name">{item.name}</div>
      <div className="filter__quantity">{count || 0}</div>
    </div>
  );

  return (
    +limit > index
      ? renderFilterItem()
      : !hideItems && renderFilterItem()
  );
};

FilterItem.defaultProps = {
  limit: 100
};

export default FilterItem;
